import { create } from 'zustand';

/**
 * v9 §A3 "Finish your profile" gate. Express accounts (guests from a link)
 * skip gender, country, avatar and interests; Popin Live and filters wait
 * for them. `request()` opens the sheet (also on a 409 profile_incomplete).
 */
interface FinishProfileState {
  open: boolean;
  request: () => void;
  close: () => void;
}

export const useFinishProfile = create<FinishProfileState>((set) => ({
  open: false,
  request: () => set({ open: true }),
  close: () => set({ open: false }),
}));
